import React, { useState, useEffect } from 'react'
import BankQuestionService from '../../services/bankQuestionService_moi'

const TrueFalseDataTest: React.FC = () => {
  const [testResults, setTestResults] = useState<any[]>([])
  const [loading, setLoading] = useState(false)

  const bankService = new (BankQuestionService as any)()

  const testTrueFalseData = async () => {
    setLoading(true)
    const results: any[] = []

    // Test cases for available lessons in public/bank
    const testCases = [
      { lop: '11', chuong: '1', bai: '1' },
      { lop: '11', chuong: '1', bai: '4' },
      { lop: '11', chuong: '2', bai: '7' }
    ]

    for (const testCase of testCases) {
      try {
        console.log(`Testing L${testCase.lop}_C${testCase.chuong}_B${testCase.bai}`)
        
        // Load DS questions directly
        const trueFalseQuestions = await bankService.getTrueFalseQuestions(
          testCase.lop, 
          testCase.chuong, 
          testCase.bai
        )

        results.push({
          lesson: `L${testCase.lop}_C${testCase.chuong}_B${testCase.bai}`,
          totalQuestions: trueFalseQuestions.length,
          trueFalseCount: trueFalseQuestions.length,
          questions: trueFalseQuestions.map(q => ({
            id: q.id,
            type: q.type,
            cau_hoi: q.cau_hoi,
            statement_a: q.statement_a,
            statement_b: q.statement_b,
            statement_c: q.statement_c,
            statement_d: q.statement_d,
            lua_chon: q.lua_chon,
            dap_an_dung: q.dap_an_dung,
            solution_a: q.solution_a,
            solution_b: q.solution_b,
            solution_c: q.solution_c,
            solution_d: q.solution_d
          }))
        })

      } catch (error) {
        console.error(`Error testing ${testCase.lop}-${testCase.chuong}-${testCase.bai}:`, error)
        results.push({
          lesson: `L${testCase.lop}_C${testCase.chuong}_B${testCase.bai}`,
          error: error.message,
          totalQuestions: 0,
          trueFalseCount: 0,
          questions: []
        })
      }
    }

    setTestResults(results)
    setLoading(false)
  }

  useEffect(() => {
    testTrueFalseData()
  }, [])

  return (
    <div className="p-6 max-w-6xl mx-auto">
      <h1 className="text-2xl font-bold mb-6">Test True/False Data Loading</h1>
      
      {loading && (
        <div className="text-center py-8">
          <div className="text-lg">Đang tải dữ liệu...</div>
        </div>
      )}

      <div className="space-y-6">
        {testResults.map((result, index) => (
          <div key={index} className="border border-gray-300 rounded-lg p-4">
            <h2 className="text-xl font-semibold mb-4">{result.lesson}</h2>
            
            {result.error ? (
              <div className="text-red-600 mb-4">
                <strong>Lỗi:</strong> {result.error}
              </div>
            ) : (
              <div className="mb-4">
                <div className="text-sm text-gray-600 mb-2">
                  Tổng câu hỏi: {result.totalQuestions} | 
                  Câu đúng sai: {result.trueFalseCount}
                </div>
              </div>
            )}

            {result.questions && result.questions.length > 0 && (
              <div className="space-y-4">
                <h3 className="text-lg font-medium">Câu hỏi đúng sai:</h3>
                {result.questions.map((question: any, qIndex: number) => (
                  <div key={qIndex} className="bg-gray-50 p-4 rounded border">
                    <div className="mb-3">
                      <strong>ID:</strong> {question.id} | 
                      <strong> Type:</strong> {question.type}
                    </div>
                    
                    <div className="mb-3">
                      <strong>Câu hỏi chính:</strong>
                      <div className="mt-1 text-gray-700">{question.cau_hoi}</div>
                    </div>

                    {/* Statement fields */}
                    <div className="mb-3">
                      <strong>Statement Fields:</strong>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-2 mt-2">
                        {question.statement_a && (
                          <div className="bg-blue-50 p-2 rounded">
                            <strong>A:</strong> {question.statement_a}
                          </div>
                        )}
                        {question.statement_b && (
                          <div className="bg-blue-50 p-2 rounded">
                            <strong>B:</strong> {question.statement_b}
                          </div>
                        )}
                        {question.statement_c && (
                          <div className="bg-blue-50 p-2 rounded">
                            <strong>C:</strong> {question.statement_c}
                          </div>
                        )}
                        {question.statement_d && (
                          <div className="bg-blue-50 p-2 rounded">
                            <strong>D:</strong> {question.statement_d}
                          </div>
                        )}
                      </div>
                      
                      {!question.statement_a && !question.statement_b && 
                       !question.statement_c && !question.statement_d && (
                        <div className="text-orange-600 mt-2">
                          ⚠️ Không có trường statement_a/b/c/d
                        </div>
                      )}
                    </div>

                    {/* Lua chon fallback */}
                    {question.lua_chon && question.lua_chon.length > 0 && (
                      <div className="mb-3">
                        <strong>Lua_chon (fallback):</strong>
                        <div className="mt-1">
                          {question.lua_chon.map((option: string, oIndex: number) => (
                            <div key={oIndex} className="text-gray-600">
                              {String.fromCharCode(65 + oIndex)}: {option}
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    <div className="mb-3">
                      <strong>Đáp án đúng:</strong>
                      <span className="ml-2 text-green-600">
                        {JSON.stringify(question.dap_an_dung)}
                      </span>
                    </div>

                    {/* Solution fields */}
                    <div className="mb-3">
                      <strong>Solution Fields:</strong>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-2 mt-2">
                        {question.solution_a && (
                          <div className="bg-green-50 p-2 rounded text-sm">
                            <strong>Sol A:</strong> {question.solution_a}
                          </div>
                        )}
                        {question.solution_b && (
                          <div className="bg-green-50 p-2 rounded text-sm">
                            <strong>Sol B:</strong> {question.solution_b}
                          </div>
                        )}
                        {question.solution_c && (
                          <div className="bg-green-50 p-2 rounded text-sm">
                            <strong>Sol C:</strong> {question.solution_c}
                          </div>
                        )}
                        {question.solution_d && (
                          <div className="bg-green-50 p-2 rounded text-sm">
                            <strong>Sol D:</strong> {question.solution_d}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}

            {result.questions && result.questions.length === 0 && !result.error && (
              <div className="text-gray-500">Không có câu hỏi đúng sai nào được tìm thấy</div>
            )}
          </div>
        ))}
      </div>

      <div className="mt-6">
        <button
          onClick={testTrueFalseData}
          disabled={loading}
          className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 disabled:opacity-50"
        >
          {loading ? 'Đang tải...' : 'Test lại'}
        </button>
      </div>
    </div>
  )
}

export default TrueFalseDataTest